import { openMessageAttachment } from "./openMessageAttachment";
import { Link } from "react-router";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { toast } from "sonner";
import { getFileAttachementByName } from "../../api/fileAttachement";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

interface Props {
  files: any[];
}
const DocsInMessages = ({ files }: Props) => {
  const handleGetAssignementFile = async (fileName: string) => {
    try {
      await openMessageAttachment(() => getFileAttachementByName(
        "Message",
        fileName,
        buildPermissionContext(Resource.MESSAGE, Action.READ),
      ));
    } catch (error: any) {
      // console.log("Erreur lors du téléchargement du fichier: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  return (
    <div className="mb-4 pb-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4>Documents des messages</h4>
      </div>
      {files.length > 0 ? (
        <div className="row g-3">
          {files.map((file: any) => {
            const fileExt = file?.filename?.split(".").pop()?.toLowerCase();
            const iconMap: Record<string, string> = {
              pdf: "assets/img/icons/pdf-02.svg",
              xls: "assets/img/icons/xls.svg",
              xlsx: "assets/img/icons/xls.svg",
              doc: "assets/img/icons/word.svg",
              docx: "assets/img/icons/word.svg",
              ppt: "assets/img/icons/ppt.svg",
              pptx: "assets/img/icons/ppt.svg",
            };
            const iconSrc = iconMap[fileExt] || "assets/img/icons/folder.svg";

            const formatBytes = (bytes?: number) => {
              if (!bytes) return " ";
              if (bytes < 1024) return bytes + " B";
              const kb = bytes / 1024;
              if (kb < 1024) return kb.toFixed(1) + " KB";
              const mb = kb / 1024;
              return mb.toFixed(1) + " MB";
            };

            return (
              <div key={file.id} className="col-md-6 col-lg-4">
                <div className="card border rounded-3 bg-white h-100">
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <ImageWithBasePath
                        src={iconSrc}
                        alt="File"
                        className="me-2 flex-shrink-0"
                        // style={{ width: 48, height: 48 }}
                      />
                      <div className="dropdown">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="dropset"
                        >
                          <i className="fa fa-ellipsis-v" />
                        </Link>
                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() =>
                                handleGetAssignementFile(file?.filename)
                              }
                            >
                              Télécharger
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <h6 className="card-title text-truncate mb-2">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleGetAssignementFile(file?.filename);
                        }}
                      >
                        {file.filename}
                      </Link>
                    </h6>

                    <div className="mt-auto d-flex align-items-center justify-content-between text-muted small">
                      <span>
                        {new Date(file.createdAt).toLocaleDateString("fr-FR")}
                      </span>
                      <span className="d-flex align-items-center">
                        <i className="ti ti-circle-filled fs-6 me-1" />
                        {formatBytes(file.size)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="border rounded-3 bg-white p-3 mb-2 text-center text-muted">
          Aucun Documents.
        </div>
      )}
    </div>
  );
};

export default withPermission(
  DocsInMessages,
  [buildPermission(Resource.MESSAGE, Action.READ)],
  "masquer",
);
